import { FC } from 'react';
import styles from './styles.module.css';
import classNames from 'classnames';
import { driver } from '../../../../types/workTime';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { faCircle } from '@fortawesome/free-regular-svg-icons';

type Props = {
  workTimes: driver[];
  month: string;
};
const WorkTimesTable: FC<Props> = ({ workTimes, month }) => {
  const week = (date: number) => {
    const day = new Date(month.concat('/', String(date))).getDay();
    const weekStr = ['日', '月', '火', '水', '木', '金', '土'][day];
    return weekStr;
  };

  const getDays = () => {
    let monthStr = month.slice(-2);
    monthStr = monthStr.includes('/') ? monthStr.replace('/', '0') : monthStr;
    const getLastDate = new Date(
      Number(month.slice(0, 4)),
      Number(monthStr),
      0
    );
    const dayList = [];
    for (let i = 1; i <= getLastDate.getDate(); i++) {
      dayList.push(i);
    }
    return dayList;
  };

  const changeWorkInfo = (workInfo: number, userId: number, date: string) => {
    switch (workInfo) {
      case 0:
        return <td className={styles.dataCell} key={userId + date}></td>;
      case 1:
        return (
          <td className={styles.dataCell} key={userId + date}>
            <FontAwesomeIcon
              icon={faCircle}
              className={styles.isPossibleMark}
            />
          </td>
        );
      case 2:
        return (
          <td className={styles.isImpossibleDataCell} key={userId + date}>
            <FontAwesomeIcon
              icon={faXmark}
              className={styles.isImpossibleMark}
            />
          </td>
        );
      case 3:
        return (
          <td className={styles.isImpossibleDataCell} key={userId + date}>
            <div className={styles.isHalfImpossible}>
              午前
              <FontAwesomeIcon icon={faXmark} className={styles.icon} />
            </div>
          </td>
        );
      case 4:
        return (
          <td className={styles.isImpossibleDataCell} key={userId + date}>
            <div className={styles.isHalfImpossible}>
              午後
              <FontAwesomeIcon icon={faXmark} className={styles.icon} />
            </div>
          </td>
        );
    }
  };

  return (
    <table className={classNames(styles.table, 'rounded-corners')}>
      <thead>
        <tr className={styles.head}>
          <th className={classNames(styles.headCell, styles.center, styles.id)}>
            ID
          </th>
          <th className={classNames(styles.headCell, styles.name)}>名前</th>
          {getDays().map((i) => (
            <th
              key={i}
              className={classNames(
                styles.headCell,
                styles.center,
                styles.date
              )}
            >
              {i}({week(i)})
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {workTimes.map((workTime) => (
          <tr key={workTime.userId}>
            <td className={styles.dataCell}>
              <div className={styles.userNo}>{workTime.userNo}</div>
            </td>
            <td className={styles.dataCell}>
              <div className={styles.driverName}>{workTime.driverName}</div>
            </td>
            {workTime.dates.map((date) =>
              changeWorkInfo(
                date.workTime && date.workTime.id ? date.workTime.id : 0,
                workTime.userId,
                date.date
              )
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default WorkTimesTable;
